// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".go-back[data-v-be09b496]{background-color:#addbe5;color:#00008b;padding:8px}", ""]);
// Exports
module.exports = exports;
